module.exports = __webpack_public_path__ + "static/media/back1.2ac5616c.svg";